import {
  Box,
  Button,
  ButtonGroup,
  Checkbox,
  CheckboxGroup,
  FormControl,
  FormLabel,
  Popover,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
  Stack,
  useBoolean,
  VStack,
} from "@chakra-ui/react";
import { Controller, useForm } from "react-hook-form";
import { HiOutlineFilter } from "react-icons/hi";
import { useSearchParams } from "react-router-dom";

import { PROPERTY_TYPES } from "src/common/types";

type Filters = {
  propertyType: string[];
};

export const DealerOrganizationPropertiesFilterPopover = () => {
  const [popoverState, popoverControls] = useBoolean();
  const [searchParams, setSearchParams] = useSearchParams();

  const { control, handleSubmit } = useForm<Filters>({
    defaultValues: {
      propertyType: searchParams.get("propertyType")?.split(",") || [],
    },
  });

  const onSubmit = handleSubmit((filters: Filters) => {
    setSearchParams((prev) => {
      const next = new URLSearchParams(prev);

      Object.entries(filters).forEach(([key, value]) => {
        if (value && value.length) {
          next.set(key, Array.isArray(value) ? value.join(",") : value);
        } else {
          next.delete(key);
        }
      });

      return next;
    });

    popoverControls.off();
  });

  return (
    <Popover
      closeOnBlur={false}
      isLazy
      isOpen={popoverState}
      lazyBehavior="keepMounted"
      onOpen={popoverControls.on}
      onClose={popoverControls.off}
    >
      <PopoverTrigger>
        <Button leftIcon={<HiOutlineFilter />}>Filters</Button>
      </PopoverTrigger>

      <PopoverContent display="flex">
        <PopoverHeader>Filters</PopoverHeader>
        <PopoverCloseButton />
        <PopoverBody>
          <form onSubmit={onSubmit}>
            <VStack align="start" gap="6">
              <Box width="100%">
                <Controller
                  name="propertyType"
                  control={control}
                  render={({ field }) => (
                    <FormControl>
                      <FormLabel htmlFor="propertyType">
                        Property Type
                      </FormLabel>
                      <CheckboxGroup {...field} isDisabled={field.disabled}>
                        <Stack
                          spacing={[1, 5]}
                          direction={["column", "row"]}
                          id="propertyType"
                        >
                          {" "}
                          {PROPERTY_TYPES.map((type) => (
                            <Checkbox key={type} value={type}>
                              {type}
                            </Checkbox>
                          ))}
                        </Stack>
                      </CheckboxGroup>
                    </FormControl>
                  )}
                />
              </Box>

              <Box width="100%">
                <ButtonGroup display="flex" justifyContent="flex-end">
                  <Button type="button" onClick={popoverControls.off}>
                    Cancel
                  </Button>
                  <Button type="submit" colorScheme="brand.blue">
                    Apply Filters
                  </Button>
                </ButtonGroup>
              </Box>
            </VStack>
          </form>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
};
